import React from "react";
import CustomCard from "../../../../components/Dashboard/CustomCard";
import { SettingOutlined } from '@ant-design/icons';
import { Col, Row, Select } from "antd";
import AnyalyticsPieChart from "./Charts/PieChart";
import Box from "../../../../components/Box/Box";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import BarChartComponent from "./Charts/BarChart";
import BarChartHorizontal from "./Charts/BarChartHorizontal";
import AverageBasePay from "./AvrageBasePay/AvrageBasePay";
import AvrageBasePayFilter from "./AvrageBasePay/AvrageBasePayFilter";

const PayRollAnylytics: React.FC = () => {

    const CompensationDistributionByDepartment = [
        { name: "Software Developer", value: 11182548 },
        { name: "Business Developer", value: 6500000 },
        { name: "Human Resource", value: 3200000 },
        { name: "Account Development", value: 173190 },
    ];


    const CompensationDistributionByLocation = [
        { name: "Bangalore", value: 11182548 },
        { name: "Mumbai", value: 6500000 },
        { name: "Chennai", value: 3200000 },
        { name: "Delhi", value: 173190 },
    ]

    const barChartConfig = [
        { month: "Apr 23", planned: 1200000, actual: 900000 },
        { month: "May 23", planned: 1000000, actual: 600000 },
        { month: "Jun 23", planned: 1200000, actual: 800000 },
        { month: "Jul 23", planned: 1200000, actual: 900000 },
        { month: "Aug 23", planned: 1000000, actual: 1000000 },
        { month: "Sep 23", planned: 1000000, actual: 1000000 },
        { month: "Oct 23", planned: 1000000, actual: 1000000 },
        { month: "Nov 23", planned: 1000000, actual: 1000000 },
        { month: "Dec 23", planned: 1000000, actual: 1000000 },
        { month: "Jan 24", planned: 1000000, actual: 1000000 },
        { month: "Feb 24", planned: 1000000, actual: 1000000 },
        { month: "Mar 24", planned: 1000000, actual: 1000000 },
    ]

    const SalaryChartData = [
        {
            year: "FY 2020 - 2021",
            "0-05L": 5,
            "05-10L": 10,
            "10-20L": 20,
            "20-40L": 5,
            "40L & above": 2,
        },
        {
            year: "FY 2021 - 2022",
            "0-05L": 8,
            "05-10L": 12,
            "10-20L": 25,
            "20-40L": 6,
            "40L & above": 3,
        },
        {
            year: "FY 2022 - 2023",
            "0-05L": 6,
            "05-10L": 14,
            "10-20L": 22,
            "20-40L": 7,
            "40L & above": 4,
        },
        {
            year: "FY 2023 - 2024",
            "0-05L": 50,
            "05-10L": 20,
            "10-20L": 5,
            "20-40L": 25,
            "40L & above": 10,
        },
    ];


    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <div style={{ display: "flex", gap: "1rem" }}>
                    <CustomCard
                        icon={<SettingOutlined />}
                        title="Last Salary Processed"
                        subtitle="JUL 2023"
                        value="INR 9,97,423"
                    />
                    <CustomCard
                        icon={<SettingOutlined />}
                        title="Upcoming Salary"
                        subtitle="JUL 2023"
                        value="INR 9,97,423"
                    />
                    <CustomCard
                        icon={<SettingOutlined />}
                        title="Upcoming Revisions"
                        subtitle="JUL 2023"
                        value="0"
                    />
                    <CustomCard
                        icon={<SettingOutlined />}
                        title="Pending Revisions"
                        subtitle="JUL 2023"
                        value="0"
                    />
                </div>
            </Col>
            <Col span={24}>
                <HeadingSubHeading titleProps={{ level: 5 }} title="Compensation Summary"
                    actions={
                        <Select style={{ minWidth: 150 }} placeholder={"Select Financial Year"}>
                            <Select.Option value="FY_2020_2021">FY 2020 - 2021</Select.Option>
                            <Select.Option value="FY_2021_2022">FY 2021 - 2022</Select.Option>
                            <Select.Option value="FY_2022_2023">FY 2022 - 2023</Select.Option>
                            <Select.Option value="FY_2023_2024">FY 2023 - 2024</Select.Option>
                        </Select>
                    }
                />
            </Col>
            <Col span={24}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Box title="Compensation Distribution by Department">
                            <AnyalyticsPieChart data={CompensationDistributionByDepartment} />
                        </Box>
                    </Col>
                    <Col span={12}>
                        <Box title="Compensation Distribution by Location">
                            <AnyalyticsPieChart data={CompensationDistributionByLocation} />
                        </Box>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Box title="Planned Vs Actual Compensation (Variance) - Past Months">
                    <BarChartComponent data={barChartConfig} />
                </Box>
            </Col>
            <Col span={24}>
                <Box title={'Employees by salary range (Last 4 years)'}>
                    <BarChartHorizontal data={SalaryChartData} />
                </Box>
            </Col>
            <Col span={24}>
                <Box title={"Average Base Pay"} actions={<AvrageBasePayFilter />}>
                    <AverageBasePay />
                </Box>
            </Col>
        </Row>
    );
};

export default PayRollAnylytics;
